export default __webpack_public_path__ + "static/media/mevpay.3de4d7d0.ico";